import {React,useEffect,useRef,useState} from 'react';
import CoupansOffersView from '../../views/PartnerView/CoupansOffersView';
import { useBranchContext } from '../Context/BranchContext';
const CoupansOffersComponent=()=>{
    
    const data=useRef();
    const[loading,setLoading]=useState(true);
    const error=useRef('');
    const didFetch=useRef('false');
    const {branches,FetchBranches} = useBranchContext();
    
    const getData = async () => {
       
        try {
                await FetchBranches();
              
                setLoading(false); // Set loading to false once data is fetched
           
        
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };
    useEffect(() => {
        
            if (!didFetch.current) {
              getData();    
              didFetch.current = true; // Mark the API call as done
            }
          });
   
    return(

       <div>
        {/*!loading && branches!==null && */}
        {<CoupansOffersView/>}
       </div>
    )


};
export default CoupansOffersComponent;